import { Breakpoints } from '@x/common/responsive';
import { SwiperOptions } from 'swiper/types/swiper-options';

export const PRODUCT_SWIPER_OPTIONS_BREAKPOINTS = {
  0: { slidesPerView: 2, shortSwipes: true },
  576: { slidesPerView: 2, shortSwipes: false },
  768: { slidesPerView: 3, shortSwipes: false },
  1200: { slidesPerView: 3, shortSwipes: false },
} as Record<Breakpoints, SwiperOptions>;

export const PRODUCT_SWIPER_OPTIONS: SwiperOptions = {
  spaceBetween: 10,
  navigation: true,
  slidesPerView: 3,
  breakpoints: { ...PRODUCT_SWIPER_OPTIONS_BREAKPOINTS },
};
